import Image from "next/image";

type BrandLockupProps = {
  className?: string;
  priority?: boolean;
  appearance?: "auto" | "ink" | "reverse";
};

export function BrandLockup({ className, priority = false, appearance = "auto" }: BrandLockupProps) {
  return (
    <span role="img" aria-label="TA3NA" className={["brand-lockup", `brand-lockup--${appearance}`, className].filter(Boolean).join(" ")}>
      {(["ink", "reverse"] as const).filter((variant) => appearance === "auto" || appearance === variant).map((variant) => (
        <Image
          alt=""
          aria-hidden="true"
          className={`brand-lockup__image brand-lockup__image--${variant}`}
          height={1506}
          key={variant}
          loading={priority ? "eager" : "lazy"}
          src={`/brand/ta3na-wordmark-canonical-${variant}.svg`}
          unoptimized
          width={5795}
        />
      ))}
    </span>
  );
}
